import React, { useEffect, useRef, useState } from "react"
import SearchBox from "components/Common/SearchBox"
import DateTimeField from "components/Common/DateTimeField"
import { useSelector } from "react-redux"
import Select from "react-select"
import { withFloatingSurface } from "components/Common/selectSurface"

export default function AdvancedFilters({ values, onChange, locations = [] }) {
  const sports = useSelector(state => state.session?.settings?.activeSports || [])
  const [search, setSearch] = useState(values.search || "")
  const timer = useRef()
  useEffect(() => { clearTimeout(timer.current); setSearch(values.search || "") }, [values])
  useEffect(() => () => clearTimeout(timer.current), [])
  const select = (key, label, options) => <div className="fm-filter" key={key}>
    <label htmlFor={`fm-${key}`}>{label}</label>
    <Select styles={withFloatingSurface()} inputId={`fm-${key}`} options={options} placeholder="All" isClearable
      value={options.find(option => option.value === values[key]) || (values[key] ? { value: values[key], label: values[key] } : null)}
      onChange={option => onChange(key, option?.value || "")} />
  </div>
  const options = pairs => pairs.map(([value, label]) => ({ value, label }))
  return <div className="fm-filters mb-3">
    <div className="fm-filter-row">
      <div className="fm-filter fm-search"><label htmlFor="fm-search">Search</label>
        <SearchBox id="fm-search" placeholder="Search by player id, name, email or match id" value={search}
          onValueChange={value => { setSearch(value); clearTimeout(timer.current); timer.current = setTimeout(() => onChange("search", value.trim()), 300) }}
          onClear={() => { clearTimeout(timer.current); setSearch(""); onChange("search", "") }} />
      </div>
      {select("sportType", "Sport", options(sports.map(sport => [sport, sport.charAt(0).toUpperCase() + sport.slice(1)])))}
      {select("status", "Match status", options([["active", "Open"], ["onHold", "On-Hold"], ["completed", "Completed"], ["canceled", "Canceled"], ["noMatch", "No match"], ["deleted", "Deleted"]]))}
    </div>
    <details className="mt-2" open={Boolean(values.gameType || values.matchType || values.location || values.score || values.fromDate || values.toDate) || undefined}>
      <summary>More filters</summary><div className="fm-filter-row mt-2">
        {select("gameType", "Game type", options([["singles", "Singles"], ["doubles", "Doubles"]]))}
        {select("matchType", "Match type", options([["ranked", "Ranked"], ["unranked", "Unranked"]]))}
        {select("location", "Location", locations.map(item => ({ value: `${item.city ?? "null"}, ${item.country}`, label: `${item.city || "All cities"}, ${item.country} (${item.total})` })))}
        {select("score", "Recorded score", options([["true", "Yes"], ["false", "No"]]))}
        {["fromDate", "toDate"].map((key, index) => <div className="fm-filter" key={key}>
          <label htmlFor={`fm-${key}`}>{index ? "End date (UTC)" : "Start date (UTC)"}</label>
          <DateTimeField id={`fm-${key}`} mode="date" value={values[key] || ""} onChange={event => onChange(key, event.target.value)} zoneLabel="UTC"
            {...(index ? { rangeStart: values.fromDate || "" } : { rangeEnd: values.toDate || "" })} />
        </div>)}
      </div>
    </details>
  </div>
}
